import React from 'react';

const ModalFormFooter = ({
  onCancel,
  onSubmit,
  isLoading = false,
  isDisabled = false,
  submitLabel = 'Save Changes',
  loadingLabel,
  cancelLabel = 'Cancel',
  variant = 'primary',
}) => {
  const disabled = isLoading || isDisabled;
  const primaryClass =
    variant === 'danger'
      ? 'bg-red-500 text-white'
      : disabled
        ? 'bg-blue-500 text-white opacity-80 cursor-not-allowed'
        : 'bg-blue-500 text-white';

  return (
    <>
      <button
        type="button"
        onClick={onCancel}
        className="px-4 py-2 border rounded-md shadow-sm focus:outline-none bg-gray-500 text-white mr-2"
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        onClick={onSubmit}
        className={`px-4 py-2 border rounded-md shadow-sm focus:outline-none ${primaryClass}`}
        disabled={disabled}
      >
        {isLoading ? loadingLabel || 'Saving...' : submitLabel}
      </button>
    </>
  );
};

export default ModalFormFooter;
